/**
 * Display-only replacement for the RJSF `NullField`.
 *
 * The RJSF implementation writes `null` into the form data from a mount effect
 * whenever a `type: 'null'` field has no value. Inside an array, that effect
 * runs before the array field's `formData` prop reflects a row that was just
 * added, so the resulting change event is built from the stale array and drops
 * the new row. Rendering nothing without touching the form data keeps the
 * label-only fields purely presentational.
 *
 * @return {null}
 */
function NullField() {
    return null;
}

export default NullField;
